import { Map, Placemark, YMaps } from "@pbe/react-yandex-maps";

import i18next from "i18next";
import { Content, Info, MapLocation, Subtitles, Title, Wrapper, WrapperInner } from "./style";

export const ContactsComponent = () => {
  const { t } = i18next;

  return (
    <Wrapper>
      <Title>{t("contact_information")}</Title>
      <WrapperInner>
        <Info>
          <div>
            <Subtitles>{t("phone_number")}</Subtitles>
            <Content>
              <a href="tel:+99361826345">+99361826345</a>
            </Content>
            <Content>
              <a href="tel:+99361826345">+99361826345</a>
            </Content>
          </div>

          <div>
            <Subtitles>{t("email")}</Subtitles>
            <Content>
              <a href="mailto:info@flyashgabat.com">info@flyashgabat.com</a>
            </Content>
          </div>

          <div>
            <Subtitles>{t("workH")}</Subtitles>
            <Content>{t("working_hours")}</Content>
          </div>
        </Info>

        <MapLocation>
          <Subtitles>{t("location")}</Subtitles>
          <Content style={{ marginBottom: "20px" }}>
            Gorkut-Ata 5A, Mary city, Turkmenistan
          </Content>

          <YMaps
            preload={true}
            query={{
              lang: "ru_RU",
            }}
          >
            <Map
              width={"350px"}
              height={"350px"}
              defaultState={{
                center: [41.292454, 69.28315],
                zoom: 15,
                controls: ["zoomControl", "fullscreenControl"],
              }}
              modules={["control.ZoomControl", "control.FullscreenControl"]}
            >
              <Placemark
                defaultGeometry={[41.292454, 69.28315]}
                properties={{
                  balloonContentBody: "«Jahankeshde Hyzmat I.E.», Gorkut-Ata 5A, Mary city, Turkmenistan",
                }}
              />
            </Map>
          </YMaps>
        </MapLocation>
      </WrapperInner>
    </Wrapper>
  );
};
